/* eslint-disable no-magic-numbers */

const OPPOSITE_DIRECTION_OFFSET = 180;

export const WindIcon = ({
  angle = 0,
  height = 29,
  width = 29,
}: {
  angle?: number;
  height?: number;
  width?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 35"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    transform={`rotate(${angle + OPPOSITE_DIRECTION_OFFSET})`}
  >
    <title>Wind_Arrow</title>
    <defs />
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="wind_arrow">
        <circle id="Oval-19" fill="#e2e8f0" cx="17.5" cy="17.5" r="17.5" />
        <polygon id="Triangle-1" fill="#4A4A4A" points="25 27 17.5 24.0704639 10 27 17.5 7" />
      </g>
    </g>
  </svg>
);
